import React, { Component } from 'react';
import config from 'react-global-configuration';

class CalendarDay extends Component {


  render() {
    return (
<div>
  {this.props.turmas.map(function(turma, linha) {
    return (
      <p><a href={"/turma/editar/" + turma.id} className="link-turmas" target="_blank">{turma.name}</a></p>
    );
  })}
</div>
    );
  }
}

export default CalendarDay;



// WEBPACK FOOTER //
// ./src/Components/Calendar/Elements/CalendarDayTeam.js